import React from "react";
import DataTable from "../../../components/DataTable";
import { useNavigate } from "react-router-dom";
import { Alert, Button, App } from "antd";
import ActivityIndicator from "../../../components/ActivityIndicator";
import {
  useGetSubjectsQuery,
  useDeleteSubjectMutation,
} from "../../../store/api/subjectsApi";
import { SubjectEntity } from "../../../services/subjects/subjects.types";
import PageHeader from "../../../components/PageHeader";

const Subjects: React.FC = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  // Small full-list catalog: one list query, client-side table behavior.
  const { data, isLoading, isFetching, isError, refetch } =
    useGetSubjectsQuery();
  const [deleteSubject] = useDeleteSubjectMutation();

  const subjects = data ?? [];

  const handleEdit = (record: SubjectEntity) => {
    navigate(`/subjects/${record.id}`, { state: record.id });
  };

  const handleDelete = async (record: SubjectEntity) => {
    try {
      await deleteSubject(record.id).unwrap();
      notification["success"]({
        message: "Éxito",
        description: "La asignatura fue eliminada exitosamente!",
        placement: "top",
        duration: 3,
      });
    } catch (error: any) {
      notification["error"]({
        message: "Eliminación Erronea",
        description:
          error?.data?.message || "La asignatura no pudo ser eliminada!",
        placement: "top",
        duration: 3,
      });
    }
  };

  return (
    <div>
      <PageHeader
        title="Asignaturas"
        extra={
          <Button type="primary" onClick={() => navigate("/subjects/new")}>
            Nueva asignatura
          </Button>
        }
      />
      {isError && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message="No se pudieron cargar las asignaturas."
          action={
            <Button size="small" onClick={() => refetch()}>
              Reintentar
            </Button>
          }
        />
      )}
      {isLoading ? (
        <ActivityIndicator />
      ) : (
        <DataTable
          data={subjects.map((subject, index) => ({ ...subject, key: index }))}
          columns={[
            { title: "ID", dataIndex: "id", key: "id" },
            { title: "Nombre", dataIndex: "name", key: "name" },
            { title: "Código", dataIndex: "code", key: "code" },
          ]}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={isFetching}
        />
      )}
    </div>
  );
};

export default Subjects;
